<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw" epub:type="frontmatter epigraph" id="epigraph">
<h1 class="preface-title"> </h1>
<div class="epigraph">
<p class="epigraph"><em>If you bring forth what is within you,<br/>what you bring forth will save you.</em></p>
<p class="epigraph"><em>If you do not bring forth what is within you,<br/>what you do not bring forth will destroy you.</em></p>
<p class="attribution1"><a id="page-ix"></a>—T<span class="small-caps">HE</span> G<span class="small-caps">OSPEL OF</span> T<span class="small-caps">HOMAS</span></p></div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?3a8c3d81